var render = function render(){var _vm=this,_c=_vm._self._c;return _c('formPasswordValidation',{attrs:{"forgottenPass":_vm.forgottenPass}})
}
var staticRenderFns = []

export { render, staticRenderFns }